import React from "react";
import { Row, Col, Typography } from "antd";
import Icon from "@ant-design/icons";
import { ReactComponent as BedroomIcon } from "../../assets/icons/bedrooms.svg";
import { ReactComponent as BathroomIcon } from "../../assets/icons/bathrooms.svg";
import { ReactComponent as CeilingHeightIcon } from "../../assets/icons/ceilingHeight.svg";
import { ReactComponent as BuiltinIcon } from "../../assets/icons/builtIn.svg";
import { ReactComponent as GardenIcon } from "../../assets/icons/garden.svg";
import { ReactComponent as lotSizeIcon } from "../../assets/icons/lotSize.svg";
import { ReactComponent as parkingIcon } from "../../assets/icons/parking.svg";
import { ReactComponent as poolIcon } from "../../assets/icons/pool.svg";

function FeaturesTab(props: { property: any }) {
  const { property } = props;

  const interiorFeatures = {
    bedroom: property?.Beds,
    bathroom: property?.Baths,
    ceilingHeight: property?.CeilingHeight,
    levels: "",
    yearBuilt: property?.YearBuilt,
  };

  const exteriorFeatures = {
    lotSize: property?.LotSize,
    parking: property?.Parking?.[0],
    garden: "",
    pool: property?.Pool,
  };

  return (
    <Col>
      <Row>
        <Col
          span={10}
          style={{ display: "flex", flexDirection: "column", marginTop: 0 }}
        >
          <Typography.Title level={5} style={{ marginTop: '0px' }}>Interior</Typography.Title>
          {interiorFeatures.bedroom && (
            <Row>
              <Icon
                component={BedroomIcon}
                style={{ fontSize: "20px", marginRight: "10px" }}
              />
              <Typography.Paragraph>{`${interiorFeatures.bedroom} Bedrooms`}</Typography.Paragraph>
            </Row>
          )}
          {interiorFeatures.bathroom && (
            <Row>
              <Icon
                component={BathroomIcon}
                style={{ fontSize: "20px", marginRight: "10px" }}
              />
              <Typography.Paragraph>{`${interiorFeatures.bathroom} Bathrooms`}</Typography.Paragraph>
            </Row>
          )}
          {interiorFeatures.yearBuilt && (
            <Row>
              <Icon
                component={BuiltinIcon}
                style={{ fontSize: "20px", marginRight: "10px" }}
              />
              <Typography.Paragraph>{`Built in ${interiorFeatures.yearBuilt}`}</Typography.Paragraph>
            </Row>
          )}
          {interiorFeatures.ceilingHeight !== undefined && (
            <Row>
              <Icon
                component={CeilingHeightIcon}
                style={{ fontSize: "20px", marginRight: "10px" }}
              />
              <Typography.Paragraph>{`Ceiling height: ${interiorFeatures.ceilingHeight} ft`}</Typography.Paragraph>
            </Row>
          )}
        </Col>

        <Col
          offset={4}
          span={10}
          flex={1}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Typography.Title level={5} style={{ marginTop: '0px' }}>Exterior</Typography.Title>
          {exteriorFeatures.garden && (
            <Row>
              <Icon
                component={GardenIcon}
                style={{ fontSize: "20px", marginRight: "10px" }}
              />
              <Typography.Paragraph>{`Garden on property`}</Typography.Paragraph>
            </Row>
          )}
          {exteriorFeatures.lotSize && (
            <Row>
              <Icon
                component={lotSizeIcon}
                style={{ fontSize: "20px", marginRight: "10px" }}
              />
              <Typography.Paragraph>{`Lot size: ${exteriorFeatures.lotSize} sqft`}</Typography.Paragraph>
            </Row>
          )}

          {exteriorFeatures.parking && (
            <Row>
              <Icon
                component={parkingIcon}
                style={{ fontSize: "20px", marginRight: "10px" }}
              />
              <Typography.Paragraph>{`Parking: ${exteriorFeatures.parking}`}</Typography.Paragraph>
            </Row>
          )}
          {exteriorFeatures.pool === "true" && (
            <Row>
              <Icon
                component={poolIcon}
                style={{ fontSize: "20px", marginRight: "10px" }}
              />
              <Typography.Paragraph>{`Pool on property`}</Typography.Paragraph>
            </Row>
          )}
        </Col>
      </Row>
    </Col>
  );
}

export default FeaturesTab;
